import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '@services/modal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'cck-cookie-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {
  private readonly _modalService = inject(ModalService);
  private readonly _domSanitizer = inject(DomSanitizer);

  public content: any;
  public sanitizedContent: SafeHtml;

  ngOnInit() {
    this.getCookiePolicy();
  }

  public async getCookiePolicy() {
    this.content = await this._modalService.getCookiePolicy();
    this.sanitizedContent = this._domSanitizer.bypassSecurityTrustHtml(this.content);
  }
}
